"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToBoostYourRankings() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.3
  });
  const {
    ref: paraRef,
    isVisible: paraVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: footRef,
    isVisible: footVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const headlineWords = ["Ready", "to", "boost", "your", "rankings?"];
  return <section data-section-id="4910" id="ready-to-boost-your-rankings" className="bg-background text-foreground relative overflow-hidden ![padding:20px_24px_10px_24px]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg" style={{
      width: "600px",
      height: "600px",
      maxWidth: "90vw",
      maxHeight: "90vw",
      borderRadius: "9999px",
      border: "1px solid var(--primary)",
      opacity: 0.1
    }} />

      {}
      <span aria-hidden="true" className="absolute top-12 left-12 w-1.5 h-1.5 rounded-lg" style={{
      backgroundColor: "var(--primary)",
      borderRadius: "9999px",
      opacity: 0.6
    }} />
      <span aria-hidden="true" className="absolute top-16 right-20 w-1 h-1 rounded-lg" style={{
      backgroundColor: "var(--primary)",
      borderRadius: "9999px",
      opacity: 0.5
    }} />
      <span aria-hidden="true" className="absolute bottom-16 left-20 w-1 h-1 rounded-lg" style={{
      backgroundColor: "var(--primary)",
      borderRadius: "9999px",
      opacity: 0.5
    }} />
      <span aria-hidden="true" className="absolute bottom-12 right-12 w-1.5 h-1.5 rounded-lg" style={{
      backgroundColor: "var(--primary)",
      borderRadius: "9999px",
      opacity: 0.6
    }} />

      <div className="relative z-10 mx-auto max-w-5xl flex flex-col items-center text-center">
        {}
        

        {}
        <h2 ref={headingRef} className="font-default font-bold leading-[1.05] mt-10 !text-7xl md:mt-14" style={{
        color: "var(--foreground)"
      }}>
          <span className="block">
            {headlineWords.slice(0, 2).map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-baseline mr-3 md:mr-5">
                <span className="inline-block transition-all ease-out" style={{
              transitionDuration: "900ms",
              transitionDelay: `${i * 120}ms`,
              transform: headingVisible ? "translateY(0)" : "translateY(110%)",
              opacity: headingVisible ? 1 : 0
            }}>
                  {word}
                </span>
              </span>)}
          </span>
          <span className="block mt-2 md:mt-4">
            {headlineWords.slice(2).map((word, idx) => {
            const i = idx + 2;
            const isItalic = word === "rankings?";
            return <span key={i} data-index={idx} className="inline-block overflow-hidden align-baseline mr-3 md:mr-5">
                  <span className={`inline-block transition-all ease-out ${isItalic ? "italic" : ""}`} style={{
                transitionDuration: "900ms",
                transitionDelay: `${i * 120}ms`,
                transform: headingVisible ? "translateY(0)" : "translateY(110%)",
                opacity: headingVisible ? 1 : 0,
                color: isItalic ? "var(--primary)" : "var(--foreground)"
              }}>
                    {word}
                  </span>
                </span>;
          })}
          </span>
        </h2>

        {}
        <p ref={paraRef} className={`font-default mt-10 md:mt-12 text-lg md:text-[19px] leading-relaxed max-w-[580px] mx-auto transition-all duration-1000 ease-out ${paraVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        color: "var(--muted-foreground)",
        opacity: paraVisible ? 0.85 : 0,
        transitionDelay: "200ms"
      }}>
          Stop losing customers to competitors. We specialize in high-performance website design, 
          strategic SEO, and fixing Google Business Profile issues to help your business dominate 
          local search results.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDelay: "350ms"
      }}>
          <Button asChild size="lg" className="h-14 px-10 text-base font-default tracking-wide rounded-lg shadow-md hover:shadow-lg transition-all bg-primary text-white">
            <Link to="/ContactUsPage">Get a Free SEO Audit</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 px-10 text-base font-default tracking-wide rounded-lg bg-transparent border hover:bg-primary/5 transition-all" style={{
          borderColor: "var(--primary)",
          color: "var(--foreground)"
        }}>
            
          </Button>
        </div>

        {}
        <div ref={footRef} className={`mt-10 md:mt-12 font-default text-[11px] tracking-[0.3em] uppercase transition-all duration-1000 ease-out ${footVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        color: "var(--muted-foreground)",
        transitionDelay: "500ms"
      }}>
          Helping Small & Medium Businesses Grow Online
        </div>
      </div>
    </section>;
}